export const API_URL = process.env.REACT_APP_API_URL;
export const STORAGE = "wine-data-system";

// Add API endpoints for authentication
export const API_ENDPOINTS = {
  USER: {
    LOGIN: `${API_URL}/auth/login`,
    GET_USER: `${API_URL}/auth/me`, // Adding new endpoint
    REFRESH_TOKEN: `${API_URL}/auth/refresh-token`,
    FORGOT_PASSWORD: `${API_URL}/auth/forgot-password`,
  },
  PUBLIC: {
    LOGIN: `${API_URL}/auth/login`,
  },
  PRIVATE: {
    DASHBOARD: "/dashboard",
    USER_INFO: `${API_URL}/user/profile`,
  },
};

export const KEYS = {
  // AUTH_ACCESS: "osm-auth-access",
  // AUTH_REFRESH: "osm-auth-refresh",
};

export const URLS = {
  AUTH: {
    SIGNUP: "/signup",
    SIGNIN: "/login",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD: "/reset-password",
  },
  USER: {
    PROFILE: "/profile",
    PERSONAL_INFO: "/profile/personal-info",
  },
  JOB_LOG: {
    LIST: "/job-log",
    EDIT: "/job-logs/:id/edit",
    CREATE: "/job-logs/create",
    DETAIL: "/job-logs/:id",
  },
  CRAWLER: {
    LIST: "/crawler",
    CREATE: "/crawler/create",
    NEW_CRAWLER: "/crawler/new",
    DETAIL: "/crawler/:id",
    EDIT: "/crawler/:id/edit",
    RETAILER_GROUP: {
      LIST: "/retailer-group",
      CREATE: "/retailer-group/create",
      DETAIL: "/retailer-group/:id",
      EDIT: "/retailer-group/:id/edit",
    },
  },
  WORK_GROUP: {
    LIST: "/work-group",
    CREATE: "/work-group/create",
    DETAIL: "/work-group/:id",
    ADD_RETAILER: "/work-group/:id/add-retailer",
    WEB_CRAWLER: "/work-group-web-crawler/:id",
  },
  ROLLUP: {
    WA: {
      LIST: "/wa-rollup",
    },
    RP: {
      LIST: "/rp-rollup",
    },
  },
  DOWNLOAD: {
    LIST: "/download",
    UPLOAD: "/upload",
  },
  VALIDATION: {
    GET: "/validation",
        EDIT_WINE: '/validation/edit-wine/:id',
  },
  NARROW: {
    GET: "/narrow",
  },
  MATCHED: {
    LIST: "/matched",
    DETAIL: "/matched/:id",
  },
  NOISE: {
    GLOBAL: {
      LIST: "/global-noise",
      CREATE: "/global-noise/create",
      DETAIL: "/global-noise/:id",
    },
    NOISE_PARSER: {
      LIST: "/noise-parser",
    },
    WINE_NOISE: {
      LIST: "/wine-noise",
    },
    PRODUCER_NOISE: {
      LIST: "/producer-noise",
      CREATE: "/producer-noise/create",
      DETAIL: "/producer-noise/:id",
    },
  },
  WINE_MATCH: {
    MATCH_CONFIG: {
      CREATE: "/wine-match/match-config/create",
      LIST: "/wine-match/match-config",
      DETAIL: "/wine-match/match-config/:id",
      EDIT: "/wine-match/match-config/:id/edit",
    },
    HISTORY: {
      LIST: "/wine-match/history-match",
    },
    KEYWORD: {
      LIST: "/wine-match/keyword-match",
    },
  },
  WINE_ADDITION: {
    KEYWORD_GENERATOR: {
      CREATE: "/wine-addition",
    },
    DIRECT_INPUT: {
      CREATE: "/wine-addition/direct-input",
    },
    EXTERNAL_INPUT: {
      CREATE: "/wine-addition/external-input",
    },
    NEW_PRODUCER: "/wine-addition/new-producer",
    ADD_WINE_TO_PRODUCER: "/wine-addition/add-wine-to-producer/:id",
    EDIT_WINE: "/wine-addition/edit-wine/:id",
  },
  LOCATION_SETTINGS: {
    COUNTRY: {
      LIST: "/Site-Settings/country",
      CREATE: "/Site-Settings/country/create",
      DETAIL: (id: string) => `/Site-Settings/country/${id}`,
    },
    REGION: {
      LIST: "/Site-Settings/region",
      CREATE: "/Site-Settings/region/create",
      DETAIL: (id: string) => `/Site-Settings/region/${id}`,
    },
    SUB_REGION: {
      LIST: "/Site-Settings/sub-region",
      CREATE: "/Site-Settings/sub-region/create",
      DETAIL: (id: string) => `/Site-Settings/sub-region/${id}`,
    },
    APPELLATION: {
      LIST: "/Site-Settings/appellations",
      CREATE: "/Site-Settings/appellations/create",
      DETAIL: (id: string) => `/Site-Settings/appellations/${id}`,
    },
    SUB_APPELLATION: {
      LIST: "/Site-Settings/sub-appellation",
      CREATE: "/Site-Settings/sub-appellation/create",
      DETAIL: (id: string) => `/Site-Settings/sub-appellation/${id}`,
    },
    LOCATION: {
      LIST: "/Site-Settings/location",
      CREATE: "/Site-Settings/location/create",
      DETAIL: (id: string) => `/Site-Settings/location/${id}`,
    },
    LOCALES: {
      LIST: "/Site-Settings/locales",
      CREATE: "/Site-Settings/locales/create",
      DETAIL: (id: string) => `/Site-Settings/locales/${id}`,
    },
    VARIETIES: {
      LIST: "/Site-Settings/varieties",
      CREATE: "/Site-Settings/varieties/create",
      DETAIL: (id: string) => `/Site-Settings/varieties/${id}`,
    },
  },
  WINE_APPELLATIONS: {
    LIST: "/wine-appellations",
    CREATE: "/wine-appellations/create",
    DETAIL: (id: string) => `/wine-appellations/${id}`,
  },
  FILES: {
    UPLOAD: "/files/upload",
  },
};

export const APIS = {
  FILES: {
    UPLOAD: API_URL + "/files",
  },
  AUTH: {
    SIGNIN: API_URL + "/auth/login",
    SIGNOUT: API_URL + "/auth/logout",
    FORGOT_PASSWORD: API_URL + "/auth/forgot-password",
    RESET_PASSWORD: API_URL + "/auth/set/password",
    CHANGE_PASSWORD: API_URL + "/auth/users/password",
    SIGNUP: API_URL + "/auth/register",
    GET_USER: API_URL + "/auth/me",
  },
  USER: {
    PROFILE: API_URL + "/profile",
    PERSONAL_INFO: API_URL + "/profile/personal-info",
  },
  JOB_LOG: {
    LIST: API_URL + "/job-logs",
  },
  CRAWLER: {
    LIST: API_URL + "/web-crawlers",
    DETAIL: (id: string) => API_URL + `/web-crawlers/${id}`,
    RETAILER_GROUP: {
      LIST: API_URL + "/retailer-groups",
      DETAIL: (id: string) => API_URL + `/retailer-groups/${id}`,
    },
    RUN: (id: string) => API_URL + `/web-crawlers/${id}/run`,
    GET_COLUMNS: (id: string) => API_URL + `/web-crawlers/${id}/column-indexes`,
    UPLOAD_FILE: (id: string) => API_URL + `/web-crawlers/${id}/upload`,
    DOWNLOAD_HISTORY: API_URL + "/export-data/get-history-file",
  },
  WORK_GROUP: {
    LIST: API_URL + "/work-groups",
    DETAIL: (id: string) => API_URL + `/work-groups/${id}`,
  },
  RETAILER: {
    LIST: API_URL + "/retailers",
  },
  VALIDATION: {
      POPULATE_RETAILERS: API_URL + '/validations/populate-retailers',
      LOAD_MATCHED_RETAILERS: API_URL + '/validations/keyword-matches',
      GET_GLOBAL_NOISE: API_URL + '/global-noises',
      GET_PRODUCER_NOISE: API_URL + '/producer-noises',
      GET_WINE_NOISE: API_URL + '/wine-noises',
      SAVE_MATCHED: API_URL + '/validations/save-matched',
      ADD_NOISE_TO_PRODUCER: API_URL + '/producer-noises/by-wine-db-id',
      REMOVE_NOISE_FROM_PRODUCER: API_URL + '/producer-noises/by-wine-db-id',
  },
  LOCATION_SETTINGS: {
    COUNTRY: {
      COUNTRIES: API_URL + "/countries",
      DETAIL: (id: string) => API_URL + `/countries/${id}`,
    },
    REGION: {
      REGIONS: API_URL + "/regions",
      DETAIL: (id: string) => API_URL + `/regions/${id}`,
    },
    SUB_REGION: {
      SUB_REGIONS: API_URL + "/sub-regions",
      CREATE: API_URL + "/sub-regions",
      DETAIL: (id: string) => API_URL + `/sub-regions/${id}`,
    },
    LOCATION: {
      LOCATIONS: API_URL + "/locations",
      DETAIL: (id: string) => API_URL + `/locations/${id}`,
    },
    LOCALES: {
      LOCALES: API_URL + "/locations/locales",
      CREATE: (id: string) => API_URL + `/locations/${id}/locales`,
      DETAIL: (id: string) => API_URL + `/locations/locales/${id}`,
    },
    APPELLATION: {
      APPELLATIONS: API_URL + "/appellations",
      CREATE: API_URL + "/appellations",
      DETAIL: (id: string) => API_URL + `/appellations/${id}`,
      TREE: API_URL + "/appellations/get-appellation/tree",
    },
    SUB_APPELLATION: {
      SUB_APPELLATIONS: API_URL + "/sub-appellations",
      CREATE: API_URL + "/sub-appellations",
      DETAIL: (id: string) => API_URL + `/sub-appellations/${id}`,
    },
  },
  WINE_APPELLATIONS: {
    LIST: API_URL + "/wine-appellations/",
    CREATE: API_URL + "/wine-appellations",
    DETAIL: (id: string) => API_URL + `/wine-appellations/${id}`,
  },
  WINE_MATCH: {
    MATCH_CONFIG: {
      LIST: API_URL + "/match-configs",
      DETAIL: (id: string) => API_URL + `/match-configs/${id}`,
      DELETE: (id: string) => API_URL + `/match-configs/${id}`,
      PREVIEW: (id: string | number) =>
        API_URL + `/web-crawlers/${id}/preview-file`,
    },
    HISTORY_MATCH: {
      PROCESS: API_URL + "/wine-matches/proceed",
      DOWNLOAD: API_URL + "/wine-matches/download",
      DOWNLOAD_EACH: API_URL + "/export-data/get-matched-file"
    },
  },
  // WINE_ADDITION: {
  //     DIRECT_INPUT: {
  //         VARIETY: API_URL + '/variety',
  //         COLOR: API_URL + '/color',
  //         SWEETNESS: API_URL + '/sweetness',
  //         TYPE: API_URL + '/type',
  //         LITERAL_BY_REG_CODE: API_URL + '/wine/literal-by-reg-code',
  //         REG_CODES: API_URL + '/wine/reg-code',
  //         GET_LITERAL: API_URL + `/wine/literal-by-reg-code`,
  //         SUB_APPELLATIONS: API_URL + '/options/sub-appellation',
  //         APPELLATION_TREE: API_URL + '/options/get-appellation-tree',
  //         NOISE: API_URL + '/options/get-noise',
  //     },
  //     CREATE_NEW_PRODUCER: API_URL + '/wine',
  //     WINE_DBS: API_URL + '/wine-addition/wine-dbs',
  //     WINE: API_URL + '/wine',
  //     WINE_BY_ID: (id: string) => API_URL + `/wine/${id}`,
  //     PRODUCER: API_URL + '/producer',
  //     PRODUCER_BY_ID: (id : string) => API_URL + `/producer/${id}`,
  // },

  WINE_ADDITION: {
    DIRECT_INPUT: {
      WINES: {
        WINES: API_URL + "/wines",
        WINE_BY_ID: (id: string | number) => API_URL + `/wines/${id}`,
                WINE_BY_LITERAL: (literal: string) => API_URL + `/wines/literal/${literal}`,
        MERGE: API_URL + "/wines/merge",
        REG_CODES: API_URL + "/wines/reg-code",
        VARIETY: API_URL + "/varieties",
        COLOR: API_URL + "/colors",
        SWEETNESS: API_URL + "/sweetnesses",
        TYPE: API_URL + "/types",
        NOISE: API_URL + "/options/get-noises",
        SUB_APPELLATION: API_URL + "/options/sub-appellations",
        APPELLATION_TREE: API_URL + "/options/get-appellation-trees",
        LITERAL_BY_REG_CODE: API_URL + "/wines/literal-by-reg-code",
      },
      PRODUCERS: {
        PRODUCERS: API_URL + "/producers",
        PRODUCER_BY_ID: (id: string) => API_URL + `/producers/${id}`,
        LITERAL_BY_REG_CODE: API_URL + "/producers/literal-by-reg-code",
      },
      GENERATE_KEYWORDS: {
        WORD_ALIASES: API_URL + "/word-aliases",
        WORD_ELIMINATIONS: API_URL + "/word-eliminations",
        WORD_CHANGES: API_URL + "/word-changes",
        SPREAD_TABLES: API_URL + "/keyword-spreads/tree",
        KEYWORD_SUBSTITUTIONS: API_URL + "/keyword-substitutions",
        RESERVED_WORDS: API_URL + "/reserved-words",
        VINTAGES: API_URL + "/vintages",
      },
    },
    KEYWORD_GENERATOR: {
      UPLOAD_FILE: API_URL + "/keyword-generator/upload_for_keyword_generator",
      SAVE_FILE: API_URL + "/keyword-generator/save_keywords_to_db",
    },
    EXTERNAL_INPUT: {
      UPLOAD_FILE: API_URL + "/keyword-generator/upload-wines-addition",
      CHECK_MATCH: API_URL + "/external-inputs/check-addition-matched",
      UNDO_MATCH: API_URL + "/external-inputs/undo-match",
      ACCEPT_MATCH: API_URL + "/external-inputs/accept-match",
    },
  },

  DOWNLOAD: {
    LIST: API_URL + "/export-data/latest-files",
    GENERATE: API_URL + "/export-data/generate",
    DOWNLOAD: API_URL + "/export-data/download",
  },

  UPLOAD: {
    LIST: API_URL + '/export-data/latest-upliaded-files',
    UPLOAD_FILE: API_URL + '/export-data/upload-csv/',
    EXECUTE: API_URL + '/export-data/process-uploaded-file/:type'
  },

  ROLLUP: {
    RP_LIST: `${API_URL}/rollups/logs`,
    RP_RUN: `${API_URL}/rollups/execute-rp-rollup`,
    RP_DOWNLOAD_FILE: `${API_URL}/export-data/download-by-name`,
    WA_LIST: `${API_URL}/rollup/wa/list`,
    WA_RUN: `${API_URL}/rollup/wa/run`,
  },

  NOISE: {
    GLOBAL: {
      LIST: API_URL + "/global-noises",
      DETAIL: (id: number | string) => API_URL + `/global-noises/${id}`,
      DELETE: (id: number | string) => API_URL + `/global-noises/${id}`,
      UPDATE: (id: number | string) => API_URL + `/global-noises/${id}`,
    },
    PRODUCER: {
      LIST: API_URL + "/producer-noises",
      DETAIL: (id: number | string) => API_URL + `/producer-noises/${id}`,
      DELETE: (id: number | string) => API_URL + `/producer-noises/${id}`,
      UPDATE: (id: number | string) => API_URL + `/producer-noises/${id}`,
    },
    WINE: {
      LIST: API_URL + "/wine-noises",
      DETAIL: (id: number | string) => API_URL + `/wine-noises/${id}`,
      DELETE: (id: number | string) => API_URL + `/wine-noises/${id}`,
      UPDATE: (id: number | string) => API_URL + `/wine-noises/${id}`,
      BULK_CREATE: API_URL + "/wine-noises/add-multiple-wine-noises",
    },
  },
};

export const ACTIONS = {
  RESET_REDUCER: "ACTIONS/RESET_REDUCER",

  LOADER: {
    SHOW_LOADER: "ACTION/LOADER/SHOW_LOADER",
    HIDE_LOADER: "ACTION/LOADER/HIDE_LOADER",
  },

  USER: {
    SIGNIN: "ACTIONS/USER/LOGIN",
    USER: "ACTIONS/USER/USER",
    SIGNOUT: "ACTIONS/USER/LOGOUT",
    // FORGET_PASSWORD: "ACTIONS/USER/FORGET_PASSWORD",
    // RESET_PASSWORD: "ACTIONS/USER/RESET_PASSWORD",
    // PASSWORD_RESET: "ACTIONS/USER/PASSWORD_RESET",
  },
  ORGANIZATION: {
    ORGANIZATION: "ACTIONS/ORGANIZATION/ORGANIZATION",
  },
};

// export const SAGA_ACTIONS = {
//     USER: {
//         SIGNIN: "SAGA_ACTIONS/USER/SIGNIN",
//         SIGNOUT: "SAGA_ACTIONS/USER/SIGNOUT",
//         FORGET_PASSWORD: "SAGA_ACTIONS/USER/FORGET_PASSWORD",
//         RESET_PASSWORD: "SAGA_ACTIONS/USER/RESET_PASSWORD",
//         SIGNUP: "SAGA_ACTIONS/USER/SIGNUP",

//     },
//     JOB_LOG: {
//         LIST: "SAGA_ACTIONS/JOB_LOG/LIST",
//         DETAIL: "SAGA_ACTIONS/JOB_LOG/DETAIL",
//     },
// }
